import React, { useState } from "react";
import { ConfigProvider, TimePicker } from "antd";
import dayjs, { utc } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import "dayjs/locale/en";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Cookies from "universal-cookie";

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);

const SingleTimePicker = ({
  defaultValue = null,
  // Pass `value` to make the field controlled by the parent (same contract as SingleDatePicker).
  value = undefined,
  handleOnChange,
  isEndTime = false,
  showNow = true,
  // true: hours/minutes after the current time (in the org timezone) cannot be picked.
  disableFutureTimes = false,
}) => {
  const cookies = new Cookies();
  const timezone = cookies.get("timeZone") || "UTC";

  const [time, setTime] = useState(
    defaultValue
      ? dayjs.tz(defaultValue, "hh:mm A", timezone)
      : null
  );

  const isControlled = value !== undefined;
  const currentTime = isControlled ? value : time;

  const onChange = (val) => {
    if (!val) {
      if (!isControlled) setTime(null);
      handleOnChange(null);
      return;
    }
    const localTime = val.tz(timezone).second(0); // force seconds = 00
    if (!isControlled) setTime(localTime);
    handleOnChange(localTime);
  };

  const disabledTime = () => {
    if (!isEndTime && !disableFutureTimes) return {};
    // Read when the panel renders, so a dialog left open does not keep a stale cutoff.
    const now = dayjs().tz(timezone);
    const range = (from, to) => Array.from({ length: Math.max(to - from, 0) }, (_, i) => from + i);
    return {
      disabledHours: () => (disableFutureTimes ? range(now.hour() + 1, 24) : []),
      disabledMinutes: (selectedHour) => {
        const minutes = isEndTime && selectedHour === 0 ? [0] : []; // end time cannot be 12:00 AM
        if (disableFutureTimes && selectedHour === now.hour()) {
          minutes.push(...range(now.minute() + 1, 60));
        }
        return minutes;
      },
    };
  };

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#4F44E0",
        },
      }}
    >
      <TimePicker
        value={currentTime}
        onChange={onChange}
        format="hh:mm A"
        use12Hours
        minuteStep={1}
        placeholder="HH:MM"
        popupClassName="custom-timepicker-popup"
        style={{ width: '100%' }}
        disabledTime={disabledTime}
        showNow={showNow}
      />
    </ConfigProvider>
  );
};

export default SingleTimePicker;
